import { Empty, Spin } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../../../store/rootReducer';
import FolderStructure from '../../../../../common/FolderStructure/FolderStructure';
import { DataRoom } from '../../../../deals/redux/types';
import { GrFormNext } from 'react-icons/gr';

type Props = {
    setSelectedType: (s?: string) => void;
};

const ExecutedAgreements: React.FC<Props> = ({ setSelectedType }) => {
    const investmentUUID = useParams().uuid;
    const dealUUID = useSelector((state: RootState) => state.investments.investmentDetails?.dealUUID);

    const executedAgreements = useSelector((state: RootState) => state.investments.executedAgreements);
    const loading = useSelector((state: RootState) => state.investments.executedAgreementsLoading);
    const documents = useSelector((state: RootState) => state.investments.investmentDetails?.documents);
    const ppm = useSelector((state: RootState) => state.investments.ppm);

    const InvestmentDocuments = useMemo(() => {
        let list: DataRoom[] = [];
        if (documents && documents?.length > 0 && dealUUID) {
            documents.forEach((d) => {
                list.push({
                    name: d.title,
                    type: 'File',
                    investmentUUID: investmentUUID,
                    dealUUID: dealUUID,
                    group: 'ExecutedAgreements',
                    isDownloadable: false,
                    uuid: '',
                });
            });
        }
        return list;
    }, [documents, investmentUUID, dealUUID]);

    const PPM = useMemo(() => {
        let list: DataRoom[] = [];
        if (ppm && ppm.ppmNumber && dealUUID) {
            list.push({
                name: `Fund PPM`,
                type: 'File',
                investmentUUID: investmentUUID,
                dealUUID: dealUUID,
                group: 'PPM',
                isDownloadable: false,
                uuid: '',
            });
        }
        return list;
    }, [ppm, investmentUUID, dealUUID]);

    return (
        <div className="px-6 pb-4">
            {!loading &&
                (executedAgreements || []).concat((InvestmentDocuments || []).concat(PPM || [])).length === 0 && (
                    <nav
                        className="py-1 pt-2 px-2 lg:px-4"
                        aria-label="Breadcrumb"
                        style={{ backgroundColor: '#F4F7FD' }}
                    >
                        <li className="inline-flex items-center">
                            <span
                                className="inline-flex mr-1 items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                style={{ top: '-4px', color: '#404040' }}
                                onClick={() => setSelectedType(undefined)}
                            >
                                Documents
                            </span>
                            <span
                                className="inline-flex items-center text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                style={{ top: '-4px' }}
                            >
                                <GrFormNext
                                    className="mr-1 md:mr-1 relative"
                                    color="#26AE60"
                                    size="1.2rem"
                                    style={{ top: '1px' }}
                                />
                            </span>
                        </li>
                        <li className="inline-flex items-center ml-1">
                            <span
                                className="inline-flex items-center text-[#B1C1D4] text-sm font-semibold my-1.5 common_read_title cursor-pointer relative"
                                style={{ top: '-4px' }}
                            >
                                Executed Agreements
                            </span>
                        </li>
                    </nav>
                )}
            {!loading &&
                (executedAgreements || []).concat((InvestmentDocuments || []).concat(PPM || [])).length > 0 && (
                    <FolderStructure
                        dataFiles={(executedAgreements || []).concat((InvestmentDocuments || []).concat(PPM || []))}
                        isDeal={false}
                        setInvestmentDoc={setSelectedType}
                    />
                )}
            {loading && (
                <div className="flex justify-center items-center h-44">
                    <Spin />
                </div>
            )}
            {!loading &&
                (executedAgreements || []).concat((InvestmentDocuments || []).concat(PPM || [])).length === 0 && (
                    <div className="pt-4">
                        <Empty />
                    </div>
                )}
        </div>
    );
};

export default ExecutedAgreements;
